module.exports = __webpack_public_path__ + "assets/img/404.8e0e5a57.png";